export default __webpack_public_path__ + "static/media/cover_signup.9004bcea.png";